import api from "@/api";
import { generateQueryParams } from "@/utils";

const getAllPaymentMethods = async (filter?: any, page?: any, isLoading = false) => {
	isLoading = true;
	let data;
	await api()
		.paymentMethods.getAll()
		.then((res: any) => {
			data = res.data.map((t: any) => {
				return { key: t.id, value: t.label };
			});
			isLoading = false;
		})
		.catch((err: any) => {
			console.log(err);
			isLoading = false;
		});
	return data;
};

const getAllVehicles = async (filter?: any, page?: any, isLoading = false) => {
	isLoading = true;
	let vehiclesData;
	await api()
		.autopack.vehicles.getAll(filter)
		.then((res: any) => {
			vehiclesData = res.data.map((t: any) => {
				return { key: t.id, value: t.mark_name + " " + t.matriculation_no };
			});
			isLoading = false;
		})
		.catch((err: any) => {
			console.log(err);
			isLoading = false;
		});
	return vehiclesData;
};

const getAllDriversData = async (filter?: any, page?: any, isLoading = false) => {
	isLoading = true;
	let data: any;
	await api()
		.staffs.personal.getAll(filter)
		.then((res: any) => {
			data = res.data.map((t: any) => {
				return {
					key: t.id,
					value: t.personal_informations.name ?? "" + " " + t.personal_informations.lastname ?? "",
				};
			});
			isLoading = false;
		})
		.catch((err: any) => {
			console.log(err);
			isLoading = false;
		});
	return data;
};

const getAllTravelRoutesData = async (filter?: any, page?: any, isLoading = false) => {
	isLoading = true;
	let Data;
	await api()
		.routes.getAll(filter)
		.then((res: any) => {
			Data = res.data.map((t: any) => {
				return { key: t.id, value: t.label };
			});
			isLoading = false;
		})
		.catch((err: any) => {
			console.log(err);
			isLoading = false;
		});
	isLoading = false;

	return Data;
};

const getAllEndStationData = async (filter?: any, page?: any, isLoading = false) => {
	isLoading = true;
	let data;
	await api()
		.stations.getAll()
		.then((res: any) => {
			data = res.data.map((t: any) => {
				return { key: t.id, value: t.station_name };
			});
			isLoading = false;
		})
		.catch((err: any) => {
			console.log(err);
			isLoading = false;
		});
	return data;
};

const getAllStations = async (filter?: any, page?: any, isLoading = false) => {
	isLoading = true;
	let data;
	await api()
		.stations.getAll(generateQueryParams(filter))
		.then((res: any) => {
			data = res.data.map((t: any) => {
				return { key: t.uuid, value: t.station_name, uuid: t.uuid };
			});
			isLoading = false;
		})
		.catch((err: any) => {
			console.log(err);
			isLoading = false;
		});
	return data;
};

const getAllVehicleTypesData = async (filter?: any, page?: any, isLoading = false) => {
	isLoading = true;
	let data;
	await api()
		.autopack.vehiclesType.getAll()
		.then((res: any) => {
			data = res.data.map((t: any) => {
				return { key: t.id, value: t.label };
			});
			isLoading = true;
		})
		.catch((err: any) => {
			console.log(err);
			isLoading = false;
		});
	return data;
};

const getAllTicketTypesData = async (filter?: any, page?: any, isLoading = false) => {
	isLoading = true;
	let data;
	await api()
		.ticketTypes.getAll(filter)
		.then((res: any) => {
			data = res.data.map((t: any) => {
				return { key: t.id, value: t.label };
			});
		})
		.catch((err: any) => {
			console.log(err);
		});
	isLoading = false;
	return data;
};

const getAllIdentityTypeCard = async (filter?: any, page?: any, isLoading = false) => {
	isLoading = true;
	let data;
	await api()
		.others.identityTypeCard.getAll()
		.then((res: any) => {
			data = res.data.map((t: any) => {
				return { key: t.id, value: t.label };
			});
		})
		.catch((err: any) => {
			console.log(err);
		});
	isLoading = false;
	return data;
};

const getAllEmbarkationData = async (filter?: any, page?: any, isLoading = false) => {
	isLoading = true;
	let data: any[]|null = null;
	// Idempotent : ne pas ré-ajouter `&paginate=none` si l'appelant l'a
	// déjà fourni (sinon on aboutit à `?...&paginate=none&paginate=none`,
	// inoffensif côté HTTP mais bruyant dans les logs).
	const filterStr = String(filter || "");
	const finalFilter = /[?&]paginate=none\b/.test(filterStr)
		? filterStr
		: `${filterStr}${filterStr.includes("?") ? "&" : "?"}paginate=none`;
	await api()
		.embarkations.getAll(finalFilter)
		.then((res: any) => {
			// Optional chaining sur `travel_docket` : un embarquement
			// PLANNED (pas encore parti) n'a pas forcément de bordereau
			// de voyage attaché. Sans le `?.`, le .map() crashait sur la
			// première ligne sans travel_docket, le .catch attrapait et
			// data restait null → dropdown vide même quand l'API
			// renvoyait correctement les embarquements.
			data = (res.data || []).map((t: any) => ({
				uuid: t.uuid,
				key: t.id,
				value: t.label,
				travelDocketID: t.travel_docket?.id ?? null,
			}));
		})
		.catch((err: any) => {
			console.log(err);
		});
	isLoading = false;
	return data;
};

const getAllTicketRatesData = async (filter?: any, page?: any, isLoading = false) => {
	isLoading = true;
	let data;
	await api()
		.rates.getAll(filter)
		.then((res: any) => {
			data = res.data.map((t: any) => {
				return { key: t.id, value: t.cost };
			});
		})
		.catch((err: any) => {
			console.log(err);
		});
	isLoading = false;
	return data;
};

const getAllTechnicalVisitStatusData = async (filter?: any, page?: any, isLoading = false) => {
	isLoading = true;
	let data;
	await api()
		.autopack.technicalVisitStatus.getAll(filter)
		.then((res: any) => {
			data = res.data.map((t: any) => {
				return { key: t.id, value: t.label, description: t.description };
			});
		})
		.catch((err: any) => {
			console.log(err);
		});
	isLoading = false;
	return data;
};

const getAllRoles = async (filter?: any, page?: any, isLoading = false) => {
	isLoading = true;
	let data;
	await api()
		.roles.getAll(generateQueryParams(filter))
		.then((res: any) => {
			data = res.data.map((t: any) => {
				return { key: t.uuid, value: t.name, uuid: t.uuid };
			});
		})
		.catch((err: any) => {
			console.log(err);
		});
	isLoading = false;
	return data;
};

const getAllCompanies = async (filter?: any, page?: any, isLoading = false) => {
	isLoading = true;
	let data;
	await api()
		.enterprise.getAll(generateQueryParams(filter))
		.then((res: any) => {
			data = res.data.map((t: any) => {
				return { key: t.uuid, value: t.name, uuid: t.uuid };
			});
		})
		.catch((err: any) => {
			console.log(err);
		});
	isLoading = false;
	return data;
};

const getSettings = async (params?: any, page?: any, isLoading = false) => {
	isLoading = true;
	let data;
	await api()
		.settings.get(generateQueryParams(params))
		.then((res: any) => {
			data = res.data;
		})
		.catch((err: any) => {
			console.log(err);
			data = null;
		});
	isLoading = false;
	return data;
};

export {
	getSettings,
	getAllTechnicalVisitStatusData,
	getAllPaymentMethods,
	getAllTicketRatesData,
	getAllEmbarkationData,
	getAllVehicles,
	getAllEndStationData,
	getAllTravelRoutesData,
	getAllDriversData,
	getAllVehicleTypesData,
	getAllTicketTypesData,
	getAllIdentityTypeCard,
	getAllRoles,
	getAllCompanies,
	getAllStations,
};
